import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {DepotListPage} from './DepotListPage'
import {DepotPage} from './DepotPage'

const DepotWrapper = () => {
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Paramètres',
                    path: '#',
                    isSeparator: false,
                    isActive: true,
                  },
                ]}
              >
                Dépôt
              </PageTitle>
              <DepotListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Dépôts', path: '/depots', isSeparator: false, isActive: true},
                ]}
              >
                Création
              </PageTitle>
              <DepotPage />
            </>
          }
        />
        <Route
          path='/:depotId/modifier'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Dépôts', path: '/depots', isSeparator: false, isActive: true},
                ]}
              >
                Modification
              </PageTitle>
              <DepotPage />
            </>
          }
        />
        <Route index element={<Navigate to='/depots/liste' />} />
      </Routes>
    </>
  )
}

export {DepotWrapper}
